import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Select,
  Button,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import moment from 'moment';
import Validator from 'validatorjs';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import _, { isEmpty, get } from 'lodash';
import { compose } from 'recompose';
import client from '../../apollo';

import withPagination from '../../containers/WithSmallerPagination';
import externalAuctionLocationsQuery from '../../graphql/externalAuctionLocationsQuery';
import externalAuctionTransactionsDataQuery from '../../graphql/externalAuctionTransactionsDataQuery';
import ExternalAuctionTransactionsList from './saleTransactionList';
import { clearSearch, setSearch } from '../../data/searchField/actions';
import { clearPage as clearPageAction, setPage as setPageAction } from '../../data/page/actions';
import { setRefreshSearch } from '../../data/refreshSearch/actions';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      vin: '',
      dealerNumber: '',
      auctionLocation: '',
      auctionLocations: [],
      saleDate: '',
      errors: {},
      searched: false,
      focusErrors: {},
      column: '',
      direction: 'descending',
      externalAuctionTransactionsData: [],
      size: 0,
    };
    const {
      clearSearchFields, dispatchRefreshSearch, refreshSearch, data,
    } = props;

    if (refreshSearch) {
      dispatchRefreshSearch(false);
      clearSearchFields({});
      const variableArguments = {
        vin: '',
        dealerNumber: '',
        auctionLocation: '',
        saleDate: '',
        auction: '',
        purchaseLocation: '',
        size: 0,
      };
      data.refetch({
        ...variableArguments,
      });
    }
  }

  componentDidMount() {
    client
      .query({
        query: externalAuctionLocationsQuery,
      })
      .then(({ data }) => {
        const result = get(data, 'externalAuctionLocations');
        if (!isEmpty(result)) {
          this.setState({
            auctionLocations: result,
          });
        }
      });
    const {
      data: { externalAuctionTransactionsData },
    } = this.props;
    this.setState({ externalAuctionTransactionsData, loading: false });
  }

  handleSort = clickedColumn => () => {
    const { column, direction, externalAuctionTransactionsData } = this.state;
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        externalAuctionTransactionsData: _.sortBy(
          externalAuctionTransactionsData,
          [clickedColumn]
        ),
        direction: 'ascending',
      });
      return;
    }

    const en = Object.assign([], externalAuctionTransactionsData);
    const dir = direction === 'ascending' ? 'descending' : 'ascending';
    this.setState({
      column: clickedColumn,
      externalAuctionTransactionsData: en.slice().reverse(),
      direction: dir,
    });
  };

  // newProps got the latest props and this.props got only the old data
  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      data: { externalAuctionTransactionsData },
    } = newProps;
    this.setState({ externalAuctionTransactionsData, loading: false });
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    const { searched } = this.state;
    if (!data.loading) {
      if (prevProps.data !== data && searched) {
        this.setState({
          loading: false,
        });
      }
    }
  }

  onDateChangeHandler = (field, date) => {
    this.setState({
      [field]: moment(new Date(date), 'YYYY-MM-DD'),
    });
  };

  onSelectHandler = field => (event, data) => {
    this.setState({
      [field]: data.value,
      loading: false,
    });
  };

  resetFields = () => {
    const { data, clearPage } = this.props;
    this.setState({
      loading: false,
      vin: '',
      dealerNumber: '',
      auctionLocation: '',
      saleDate: '',
      searched: false,
      errors: {},
      focusErrors: {},
      column: '',
      direction: 'descending',
      externalAuctionTransactionsData: [],
    });
    const variableArguments = {
      vin: '',
      dealerNumber: '',
      auctionLocation: '',
      saleDate: '',
      size: 0,
    };
    data.refetch({
      ...variableArguments,
    });
    clearPage({});
  };

  render() {
    const {
      loading, column, direction, externalAuctionTransactionsData,
      vin: vinState, dealerNumber: dealerNumberState, auctionLocation: auctionLocationState, saleDate: saleDateState,
      focusErrors, errors: errorsState, searched, auctionLocations,
    } = this.state;
    const defaultLocation = [
      {
        text: 'Select',
        key: 0,
        value: '',
      },
    ];
    const externalLocations = !isEmpty(auctionLocations)
      ? auctionLocations.map(location => {
        return {
          text: `${location.initials} - ${location.name}`,
          key: location.id,
          value: `${location.initials} - ${location.name}`,
        };
      })
      : [];

    const allLocations = [...defaultLocation, ...externalLocations];
    const externalAuctionLocations = [...new Set(allLocations)];

    const validationRules = {
      vin: 'checkValue|alphaNumeric',
      dealerNumber: 'shouldBe5mil',
      saleDate: [{ required_with: 'auctionLocation' }, 'shouldBeDate'],
    };

    Validator.register(
      'alphaNumeric',
      value => {
        return value && value.match(/^[a-zA-Z0-9]*$/);
      },
      ' Only alphanumeric characters.'
    );

    Validator.register(
      'checkValue',
      value => {
        return value && value.length === 17;
      },
      'Must be 17 characters'
    );

    Validator.register(
      'shouldBe5mil',
      value => {
        return value && /^5[0-9]{6,6}$/i.test(value);
      },
      'Must be a Dealer Number'
    );
    Validator.register(
      'shouldBeDate',
      value => {
        return value && value.format('YYYY-MM-DD');
      },
      'Must be a valid Date'
    );
    const reloadSearching = () => {
      const { data, setPage } = this.props;
      if (
        isEmpty(vinState)
        && isEmpty(dealerNumberState)
        && isEmpty(saleDateState)
        && isEmpty(auctionLocationState)
      ) {
        this.setState({
          focusErrors: {
            vin: 'Required',
            dealerNumber: 'Required',
            saleDate: 'Required',
            auctionLocation: 'Required',
          },
          searched: false,
          errors: {},
          loading: false,
        });
        this.resetFields();
        return false;
      }
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState(prevState => ({
          ...prevState,
          errors: validation.errors.all(),
          searched: false,
          focusErrors: {},
          loading: false,
        }));
        return false;
      }
      this.setState(prevState => ({
        ...prevState,
        errors: {},
        searched: true,
        focusErrors: {},
        loading: true,
      }));
      const splitActionLocation = auctionLocationState.split('-');
      const purchaseLocationParam = !isEmpty(splitActionLocation[0])
        ? splitActionLocation[0].trim().toUpperCase()
        : '';
      const formattedSaleDate = !isEmpty(saleDateState)
        ? saleDateState.format('YYYY-MM-DD')
        : saleDateState;
      const variableArguments = {
        vin: vinState,
        dealerNumber: dealerNumberState,
        saleDate: formattedSaleDate,
        purchaseLocation: purchaseLocationParam,
        size: 50,
      };
      data
        .refetch({
          ...variableArguments,
        })
        .then(() => {
          this.setState({
            loading: false,
          });
        });
      this.setState({ loading: false });
      setPage({});

      this.setState({ searched: false });
      return true;
    };

    const submitForm = () => {
      const { clearPage } = this.props;
      if (
        isEmpty(vinState)
        && isEmpty(dealerNumberState)
        && isEmpty(saleDateState)
        && isEmpty(auctionLocationState)
      ) {
        this.setState({
          focusErrors: {
            vin: 'Required',
            dealerNumber: 'Required',
            saleDate: 'Required',
            auctionLocation: 'Required',
          },
          searched: false,
          errors: {},
          loading: false,
        });
        return false;
      }
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState(prevState => ({
          ...prevState,
          errors: validation.errors.all(),
          searched: false,
          focusErrors: {},
          loading: false,
        }));
        clearPage({});
        return false;
      }
      this.setState(prevState => ({
        ...prevState,
        errors: {},
        searched: true,
        focusErrors: {},
        loading: true,
      }));
      return true;
    };

    return (
      <div>
        {loading && (
          <Dimmer active inverted>
            <Loader size='large'> Loading </Loader>{' '}
          </Dimmer>
        )}{' '}
        <Form onSubmit={submitForm}>
          <Form.Group widths='two'>
            <Form.Field error={focusErrors.vin}>
              <Form.Input
                name='vin'
                placeholder='Search by Vin'
                value={vinState}
                onChange={this.onSelectHandler('vin')}
              />
              {errorsState.vin && (
                <span style={{ color: 'red' }}>{errorsState.vin}</span>
              )}
            </Form.Field>
            <Form.Field error={focusErrors.dealerNumber}>
              <Form.Input
                name='dealerNumber'
                placeholder='Search by Dealer Number'
                value={dealerNumberState}
                onChange={this.onSelectHandler('dealerNumber')}
              />
              {errorsState.dealerNumber && (
                <span style={{ color: 'red' }}>
                  {errorsState.dealerNumber}
                </span>
              )}
            </Form.Field>
            <Form.Field error={focusErrors.auctionLocation}>
              <Select
                search
                placeholder='Search by Auction Location'
                name='auctionLocation'
                options={externalAuctionLocations}
                value={auctionLocationState}
                onChange={this.onSelectHandler('auctionLocation')}
              />
              {errorsState.auctionLocation && (
                <span style={{ color: 'red' }}>
                  {errorsState.auctionLocation}
                </span>
              )}
            </Form.Field>
            <Form.Field error={focusErrors.saleDate}>
              <DatePicker
                placeholderText='Search by Sale Date'
                selected={saleDateState}
                onChange={date => this.onDateChangeHandler('saleDate', date)}
                dateFormat='YYYY-MM-DD'
                name='saleDate'
                autoComplete='offline'
              />
              {errorsState.saleDate && (
                <span style={{ color: 'red' }}>
                  {errorsState.saleDate}
                </span>
              )}
            </Form.Field>
            <Form.Field>
              <Button
                color='green'
                id='searchButton'
                onClick={reloadSearching}
                inverted
              >
                Search
              </Button>
              <Button
                color='green'
                type='button'
                onClick={this.resetFields}
                inverted
              >
                Clear
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <br />
        {searched && (
          <ExternalAuctionTransactionsList
            externalAuctionTransactionsData={externalAuctionTransactionsData}
            column={column}
            direction={direction}
            handleSort={this.handleSort}
            searched={searched}
            vin={vinState}
            dealerNumber={dealerNumberState}
            auctionLocation={auctionLocationState}
            auction={
              auctionLocationState
                ? auctionLocationState.split(' - ')[1]
                : ''
            }
            purchaseLocation={
              auctionLocationState
                ? auctionLocationState.split(' - ')[0]
                : ''
            }
            saleDate={
              saleDateState
                ? saleDateState.format('YYYY-MM-DD')
                : ''
            }
          />
        )}{' '}
      </div>
    );
  }
}

Search.propTypes = {
  clearSearchFields: PropTypes.func,
  dispatchRefreshSearch: PropTypes.func,
  refreshSearch: PropTypes.bool,
  data: PropTypes.shape({
    refetch: PropTypes.func,
    loading: PropTypes.bool,
    externalAuctionTransactionsData: PropTypes.array,
  }),
  clearPage: PropTypes.func,
  setPage: PropTypes.func,
};

Search.defaultProps = {
  clearSearchFields: () => {},
  dispatchRefreshSearch: () => {},
  refreshSearch: false,
  data: {
    refetch: () => {},
    loading: false,
    externalAuctionTransactionsData: [],
  },
  clearPage: () => {},
  setPage: () => {},
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
  clearSearchFields: () => {
    dispatch(clearSearch());
  },
  setPage: () => {
    dispatch(setPageAction());
  },
  dispatchRefreshSearch: value => {
    dispatch(setRefreshSearch(value));
  },
  clearPage: () => {
    dispatch(clearPageAction());
  },
});

const mapStateToProps = state => {
  const {
    data: { searchFields, refreshSearch },
  } = state;
  return {
    searchFields,
    refreshSearch,
  };
};

export default compose(
  withPagination(
    externalAuctionTransactionsDataQuery,
    'externalAuctionTransactionsData'
  ),
  connect(mapStateToProps, mapDispatchToProps)
)(Search);
